import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-security-settings',
  templateUrl: './security-settings.component.html',
  styleUrls: ['./security-settings.component.scss']
})
export class SecuritySettingsComponent implements OnInit {

  twoFactorEnabled: boolean = false;

  setupStep: 'idle' | 'scan' | 'confirm' = 'idle';
  qrCodeUrl: string = '';
  manualSecret: string = '';
  verifyCode: string = '';

  showDisableModal: boolean = false;
  disablePassword: string = '';

  constructor(
    private service: ApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.load2FAStatus();
  }

  load2FAStatus() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.twoFaStatus).subscribe((resp: any) => {
      this.twoFactorEnabled = resp.response.data.twoFactorEnabled;
      this.spinner.hide();
    }, () => {
      this.toastr.error('Could not load 2FA status');
      this.spinner.hide();
    });
  }

  startSetup() {
    this.spinner.show();
    this.service.postRequest(ApiUrl.twoFaSetup, {}).subscribe((resp: any) => {
      this.qrCodeUrl = resp.response.data.qrCode;
      this.manualSecret = resp.response.data.secret;
      this.setupStep = 'scan';
      this.spinner.hide();
    }, () => {
      this.toastr.error('Failed to generate QR code');
      this.spinner.hide();
    });
  }

  proceedToConfirm() {
    this.verifyCode = '';
    this.setupStep = 'confirm';
  }

  onVerifyInput() {
    if (this.verifyCode.length === 6) {
      this.confirmSetup();
    }
  }

  confirmSetup() {
    if (this.verifyCode.length !== 6) return;
    this.spinner.show();
    this.service.postRequest(ApiUrl.twoFaVerify, { token: this.verifyCode }).subscribe(() => {
      this.twoFactorEnabled = true;
      this.setupStep = 'idle';
      this.qrCodeUrl = '';
      this.manualSecret = '';
      this.verifyCode = '';
      this.toastr.success('Two-factor authentication enabled successfully');
      this.spinner.hide();
    }, (err) => {
      const msg = err.error?.message || 'Invalid code. Please try again.';
      this.toastr.error(msg);
      this.verifyCode = '';
      this.spinner.hide();
    });
  }

  cancelSetup() {
    this.setupStep = 'idle';
    this.qrCodeUrl = '';
    this.manualSecret = '';
    this.verifyCode = '';
  }

  openDisableModal() {
    this.disablePassword = '';
    this.showDisableModal = true;
  }

  closeDisableModal() {
    this.showDisableModal = false;
    this.disablePassword = '';
  }

  confirmDisable() {
    if (!this.disablePassword) return;
    this.spinner.show();
    this.service.postRequest(ApiUrl.twoFaDisable, { password: this.disablePassword }).subscribe(() => {
      this.twoFactorEnabled = false;
      this.showDisableModal = false;
      this.disablePassword = '';
      this.toastr.success('Two-factor authentication disabled');
      this.spinner.hide();
    }, (err) => {
      const msg = err.error?.message || 'Incorrect password';
      this.toastr.error(msg);
      this.spinner.hide();
    });
  }
}
